define((require) => {
    "use strict";

    var Backbone = require("backbone");

    /**
     * Model representing metadata about an image asset.
     *
     * @class YouTubeImageModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            name: "Untitled",
            description: "",
            videoID: null,
            channelID: null,
            thumbnailUrl: "",
            duration: null
        },

        /**
         * Returns a display friendly version of the specified ISO 8601
         * duration in the format PT#M#S (The duration format used by YouTube).
         *
         * I.e. "PT2H3M38S" will return "2:03:38"
         *
         * @return {String}   A display friendly version of the specified duration.
         */
        formatDuration: function() {
            var matches = this.get("duration").match(/(\d+)(?=[MHS])/ig),
                formatDigit = function(digit) {
                    return digit.length < 2 ? ("0" + digit) : digit;
                };

            switch (matches.length) {
                // Only seconds
                case 1:
                    return "0:" + formatDigit(matches[0]);
                // Minutes and seconds
                case 2:
                    return matches[0] + ":" + formatDigit(matches[1]);
                // Hours, minutes and seconds
                default: // Case 3 handled here.
                    return matches[0] + ":" + formatDigit(matches[1]) + ":" + formatDigit(matches[2]);
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/youtube/YouTubeImageModel.js